import React, { Component } from 'react';
import Page from './page';

class HealthInsurance extends Component {

    render() {
        return (
            <Page />
        );
    }
}

export default HealthInsurance;